var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Component from 'vue-class-component';
import { namespace } from 'vuex-class';
import { UiButton } from '@claims-ia/design-system';
import { QuestionComponent, QuestionProps } from '@declaration/question';
import FileCollectionUpload from '@declaration/components/upload/FileCollectionUpload.vue';
import { ClaimFileType } from '@shared/types/file';
import { InsurerFeatureFlag, insurerHasFeature } from '@shared/featureFlags/insurerFeatureFlags';
import QuestionPanel from '@declaration/components/UI/QuestionPanel.vue';
import AmountInput from '@declaration/components/UI/AmountInput.vue';
import { GLASS_BREAKAGE_TRAD_KEYS } from '@declaration/constants/glassBreakageDamageConstants';
const claim = namespace('claim');
const qualification = namespace('qualification');
const settings = namespace('settings');
// helper removed: use qualification value or null-initialized field instead of local empty factory
let GlassDamagesReparationsQuoteUploadQuestion = class GlassDamagesReparationsQuoteUploadQuestion extends QuestionComponent {
    constructor() {
        super(...arguments);
        this.isSavingClaim = false;
        this.ClaimFileType = ClaimFileType;
    }
    get selfCareSettings() {
        return this.setting('selfCareSettings');
    }
    isRequiredQuote() {
        var _a, _b, _c, _d, _e;
        return ((_e = (_d = (_c = (_b = (_a = this.selfCareSettings) === null || _a === void 0 ? void 0 : _a.declaration) === null || _b === void 0 ? void 0 : _b.pages) === null || _c === void 0 ? void 0 : _c.glassDamagesReparationsQuoteUpload) === null || _d === void 0 ? void 0 : _d.quoteRequired) !== null && _e !== void 0 ? _e : false);
    }
    get fileUploadLabel() {
        var _a;
        return (_a = this.uploadLabel) !== null && _a !== void 0 ? _a : this.$tc('claim.damage.joint-report.upload.add');
    }
    get panelTitle() {
        return this.isRequiredQuote()
            ? this.$tc(GLASS_BREAKAGE_TRAD_KEYS['glass-damages-reparations-quote-upload-title'])
            : this.$tc(GLASS_BREAKAGE_TRAD_KEYS['glass-damages-reparations-quote-upload-title-optional']);
    }
    get sidebarTitle() {
        const key = GLASS_BREAKAGE_TRAD_KEYS['glass-damages-reparations-quote-upload-sidebar_title'];
        return this.$te(key) ? this.$tc(key) : this.panelTitle;
    }
    get answer() {
        const collection = this.selectedQuoteFileCollection;
        if (!collection)
            return null;
        const hasFiles = Array.isArray(collection.uploadedAppFiles) && collection.uploadedAppFiles.length > 0;
        return hasFiles
            ? this.$tc('claim.damage.glass_breakage.reparation_quote_upload.answer.uploaded')
            : this.$tc('claim.damage.glass_breakage.reparation_quote_upload.answer.not_uploaded');
    }
    get showHelpLink() {
        var _a;
        return (_a = !insurerHasFeature(InsurerFeatureFlag.HideHelpLink)) !== null && _a !== void 0 ? _a : true;
    }
    get reparationQuoteQuestionDescription() {
        return this.$tc('claim.damage.glass_breakage.reparation_quote_upload.description');
    }
    get selectedQuoteFileCollection() {
        const q = this.qualification.glassDamagesReparationQuote;
        if (q)
            return q;
        return { uploadedAppFiles: [] };
    }
    get selectedQuoteAmount() {
        return this.qualification.glassDamagesReparationQuoteAmount;
    }
    get validationHint() {
        var _a, _b, _c;
        const filesCount = (_c = (_b = (_a = this.selectedQuoteFileCollection) === null || _a === void 0 ? void 0 : _a.uploadedAppFiles) === null || _b === void 0 ? void 0 : _b.length) !== null && _c !== void 0 ? _c : 0;
        const hasFiles = filesCount > 0;
        const isAmountFilled = !!this.selectedQuoteAmount;
        if (isAmountFilled && !hasFiles) {
            const key = 'claim.damage.glass_breakage.reparation_quote_upload.amount_without_file';
            return this.$te(key) ? this.$tc(key) : 'Veuillez joindre le devis ou supprimer le montant.';
        }
        if (hasFiles && !isAmountFilled) {
            const key = 'claim.damage.glass_breakage.reparation_quote_upload.file_without_amount';
            return this.$te(key)
                ? this.$tc(key)
                : 'Veuillez saisir le montant du devis ou supprimer le fichier.';
        }
        return null;
    }
    onFileCollectionUpdate(fileCollection) {
        this.updateGlassBreakageDamageQualification({
            qualificationPayload: { glassDamagesReparationQuote: fileCollection },
        });
    }
    onQuoteAmountUpdate(amount) {
        this.updateGlassBreakageDamageQualification({
            qualificationPayload: {
                glassDamagesReparationQuoteAmount: amount,
            },
        });
    }
    get canValidate() {
        var _a, _b, _c;
        const filesCount = (_c = (_b = (_a = this.selectedQuoteFileCollection) === null || _a === void 0 ? void 0 : _a.uploadedAppFiles) === null || _b === void 0 ? void 0 : _b.length) !== null && _c !== void 0 ? _c : 0;
        const hasFiles = filesCount > 0;
        const isAmountFilled = !!this.selectedQuoteAmount;
        if (!this.isRequiredQuote()) {
            if (!hasFiles && !isAmountFilled)
                return true;
            return hasFiles && isAmountFilled;
        }
        return hasFiles && isAmountFilled;
    }
    onValidate() {
        this.isSavingClaim = true;
        // The backend expects a nested object or IRI for this non-nullable relation.
        this.updateAndSaveGlassBreakageDamageQualification({
            step: this.step,
            qualificationPayload: {
                glassDamagesReparationQuote: this.selectedQuoteFileCollection,
                glassDamagesReparationQuoteAmount: this.selectedQuoteAmount,
            },
        });
        this.isSavingClaim = false;
    }
};
__decorate([
    claim.State('claim')
], GlassDamagesReparationsQuoteUploadQuestion.prototype, "claim", void 0);
__decorate([
    claim.State('isUpdatingClaim')
], GlassDamagesReparationsQuoteUploadQuestion.prototype, "isUpdatingClaim", void 0);
__decorate([
    qualification.State('qualification')
], GlassDamagesReparationsQuoteUploadQuestion.prototype, "qualification", void 0);
__decorate([
    qualification.Action('updateAndSaveQualification')
], GlassDamagesReparationsQuoteUploadQuestion.prototype, "updateAndSaveGlassBreakageDamageQualification", void 0);
__decorate([
    qualification.Action('updateQualification')
], GlassDamagesReparationsQuoteUploadQuestion.prototype, "updateGlassBreakageDamageQualification", void 0);
__decorate([
    settings.Getter('setting')
], GlassDamagesReparationsQuoteUploadQuestion.prototype, "setting", void 0);
GlassDamagesReparationsQuoteUploadQuestion = __decorate([
    Component({
        components: { QuestionPanel, FileCollectionUpload, UiButton, AmountInput },
        props: QuestionProps,
    })
], GlassDamagesReparationsQuoteUploadQuestion);
export default GlassDamagesReparationsQuoteUploadQuestion;
